


















import { Component, Prop, Vue } from "vue-property-decorator"
import Client from "@/http/alioss/Client"
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState("Ali", {
      stsPayload: "stsPayload",
    }),
  },
})
export default class QFileUpload extends Vue {
  @Prop() readonly value!: string
  @Prop() readonly modelName!: string
  @Prop() readonly modelOid!: string

  stsPayload!: {
    [key: string]: string;
  }

  randomString(len) {
    len = len || 32
    const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678"
    const maxPos = chars.length
    let pwd = ""
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
  }

  async handleUpload(file) {
    await this.$store.dispatch("Ali/getAliToken")
    const client = Client(this.stsPayload)
    const random_name =
      this.randomString(6) +
      "_" +
      new Date().getTime() +
      "." +
      file.name.split(".").pop()

    await client
      .multipartUpload(random_name, file, {
        headers: {
          "x-oss-object-acl": "public-read",
        },
        callback: {
          url: this.stsPayload.callbackUrl,
          body: this.stsPayload.callbackBody,
          customValue: {
            handlerName: "MediaFile",
          },
        },
      })
      .then((response) => {
        if (response.res.statusCode === 200) {
          // this.$emit("upload", {
          //   object: response.name,
          //   bucket: response.bucket,
          //   mime_type: response.data.data.mime_type,
          //   endpoint: this.stsPayload.endpoint,
          //   id: response.data.data.id,
          // })

          this.$store.dispatch("MediaFile/updateRelation", {
            oid: response.data.data.object_id,
            payload: {
              model_oid: this.modelOid,
              model_name: this.modelName,
            },
          }).then(response => {
            this.$emit('input', response.data.data)
          })
        } else {
          // Upload Failed
        }
      })
  }
}
